import * as React from "react";
import { Progress, theme, Tooltip } from "antd";

function CircularProgressWithLabel({ color='colorPrimary', ...restProps }) {
  const {token} = theme.useToken();
  return (
    <Tooltip title={`You have completed ${restProps?.value > 100 ? 100 : restProps?.value}% of this journey`}>
      <Progress strokeColor={token[color]} type="circle" {...restProps} percent={restProps?.value > 100 ? 100 : restProps?.value} thickness={5}/>
    </Tooltip>
  );
}


export default CircularProgressWithLabel;
